<div
    [ngClass]="{
        highlightedSpot: diffusion?.isHighlight === 2 || campaign?.isHighlight === 2 || spot?.isHighlight === 2,
        fadedSpot: diffusion?.isHighlight === 1 || campaign?.isHighlight === 1 || spot?.isHighlight === 1,
        diffusionItem: true,
        diffusionLine: type === 'Wancom',
    }"
    [id]="type === 'Wancom' ? 'diffusionItem' : ''"
    cdkDrag
    [cdkDragDisabled]="type === 'Wancom' || face.diffusions.length <= 1"
>
    <!-- MARK: Menu -->
    <mat-icon class="tagListBtn menuIcon" [matMenuTriggerFor]="diffusionMenu"> more_vert </mat-icon>
    <mat-menu #diffusionMenu="matMenu" class="diffMenu">
        <button mat-menu-item (click)="seeDiffDetail(diffusion)">
            <mat-icon>video_library</mat-icon>
            <span>Voir le détail</span>
        </button>
        <hr />

        @if (type === 'Wancom' && !diffusion.isDefault) {
            <button mat-menu-item (click)="editWancomDiffParams(diffusion.diffusionId)">
                <mat-icon fontSet="material-icons-outlined">drive_file_rename_outline</mat-icon>
                <span>Modifier la diffusion</span>
            </button>
        }
        @if (type === 'Client') {
            <button mat-menu-item (click)="editDiffusionParams(diffusion.diffusionId)">
                <mat-icon fontSet="material-icons-outlined"> drive_file_rename_outline </mat-icon>
                <span>Modifier la diffusion</span>
            </button>

            <button mat-menu-item (click)="duplicateDiffusion(diffusion.campaignId)">
                <mat-icon fontSet="material-icons-outlined"> file_copy </mat-icon>
                <span>Dupliquer la diffusion</span>
            </button>
        }

        <button mat-menu-item (click)="changeCreative(diffusion, campaign?.duration)">
            <mat-icon fontSet="material-icons-outlined">subscriptions</mat-icon>
            <span> Changer de spot </span>
        </button>

        @if (diffusion.spots[0].templateRefenceId) {
            <button mat-menu-item (click)="editSpotFromTemplate(diffusion, face.faceId)">
                <mat-icon fontSet="material-icons-outlined">auto_fix_high</mat-icon>
                <span>Modifier le spot</span>
            </button>
        }

        @if (!diffusion.isDefault) {
            <button mat-menu-item (click)="editScreensDiffusion(diffusion.diffusionId)">
                <mat-icon fontSet="material-icons-outlined">add_to_queue</mat-icon>
                <span>Modifier les écrans de la diffusion</span>
            </button>

            <button mat-menu-item (click)="dialog.open(deleteconfirmationtemplate)">
                <mat-icon fontSet="material-icons-outlined">delete</mat-icon>
                <span>Supprimer la diffusion</span>
            </button>

            <!--  MARK: Dialog de suppression de diffusion client -->
            <ng-template #deleteconfirmationtemplate>
                <mat-dialog-content class="mat-typography deleteDialog">
                    <h2 mat-dialog-title>Suppression</h2>
                    <p>
                        @if (diffusion.otherScreens === 0) {
                            Êtes-vous sûr(e) de vouloir supprimer cette campagne ?
                        } @else {
                            Cette campagne diffuse également sur d'autres écrans, que souhaitez-vous faire ?
                        }
                    </p>
                </mat-dialog-content>
                <mat-dialog-actions style="justify-content: flex-end">
                    <!-- Annuler -->
                    <button mat-raised-button [mat-dialog-close]="true" cdkFocusInitial>Annuler</button>

                    @if (diffusion.otherScreens === 0) {
                        <button
                            mat-raised-button
                            color="accent"
                            [mat-dialog-close]="true"
                            (click)="deleteDiffusion(diffusion)"
                        >
                            Supprimer
                        </button>
                    } @else {
                        <button
                            mat-raised-button
                            color="accent"
                            [mat-dialog-close]="true"
                            (click)="deleteDiffForScreen(diffusion, face.faceId)"
                        >
                            Supprimer uniquement pour cet écran
                        </button>
                        <button mat-raised-button [mat-dialog-close]="true" (click)="deleteDiffusion(diffusion)">
                            Supprimer pour tous les écrans
                        </button>
                    }
                </mat-dialog-actions>
            </ng-template>
        }
    </mat-menu>

    <div
        [ngClass]="{
            diffusionLine: type === 'Client',
            wancomDiffLine: type === 'Wancom',
            draggable: type === 'Client',
        }"
    >
        @if (type === 'Client') {
            <!-- Drag indicator -->
            @if (face.diffusions.length > 1) {
                <mat-icon class="dragZone">drag_indicator</mat-icon>
            } @else {
                <mat-icon class="dragZone inactiveDragZone">drag_indicator</mat-icon>
            }
        }

        <!-- MARK: Thumbnail -->
        <div class="thumbnailPart" [ngClass]="[diffusion.spots?.length === 0 ? 'noThumbDiv' : '']" id="thumbnailItem">
            <!-- MARK: Client -->
            @if (type === 'Client') {
                @for (spot of diffusion.spots; track $index) {
                    @switch (spot?.file?.generationStatus) {
                        @case (30 || 0) {
                            <!-- Spot prêt -->
                            <div class="thumbnailDivLayer" (click)="playFile(spot.file)">
                                <mat-icon class="playArrow">play_arrow</mat-icon>
                            </div>

                            <!-- Other Screens -->
                            @if (diffusion.otherScreens > 0) {
                                <div class="otherScreenCount">
                                    <mat-icon>airplay</mat-icon>
                                    <span>+ {{ diffusion.otherScreens }}</span>
                                </div>
                            }

                            @if (spot.file?.thumbnailStorageId) {
                                <div
                                    class="thumbnailDiv"
                                    (click)="playFile(spot.file)"
                                    matTooltip="Voir la vidéo"
                                    [style.background-image]="
                                        getBackgroundImageUrl(spot.file, spot.file?.extensionType === 8)
                                    "
                                ></div>
                            } @else {
                                <mat-icon matTooltip="Miniature manquante" style="margin: auto">wallpaper</mat-icon>
                            }
                        }
                        @case (10) {
                            <div class="noContentThumb noThumbDiv">
                                <mat-icon>design_services</mat-icon>
                                <i>En attente de traitement</i>
                            </div>
                        }
                        @case (20) {
                            <div class="noContentThumb noThumbDiv">
                                <img
                                    class="processingIcon"
                                    src="../../../../assets/settingcustomslow.gif"
                                    alt="GIF en cours de traitement"
                                />
                                <i class="processingText">En cours de traitement</i>
                                @if (spot.file?.generationProgress) {
                                    <b>{{ spot.file?.generationProgress }} %</b>
                                }
                            </div>
                        }
                        @case (100) {
                            <div class="thumbnailDiv noContentThumb">
                                <mat-icon>broken_image</mat-icon>
                                <i>Erreur de génération du spot</i>
                            </div>
                        }
                        @case (null) {
                            <!-- Spot sans thumbnail ni generation status ni spotId -->
                            <div
                                class="noContentThumb"
                                (click)="changeCreative(spot, campaign.duration)"
                                matTooltip="Définir une spot"
                            >
                                <mat-icon>pan_tool_alt</mat-icon>
                                <i>Cliquez ici pour définir un spot</i>
                            </div>
                        }
                    }
                }
            }

            <!-- MARK: Wancom -->
            @if (type === 'Wancom') {
                @if (!spot.moderationFile || spot.moderationFile?.length <= 0) {
                    <!-- Pas de spot -->
                    @if (!spot.spotId) {
                        <div
                            class="noContentThumb"
                            (click)="changeCreative(diffusion, campaign.duration)"
                            matTooltip="Définir un spot"
                        >
                            <mat-icon>pan_tool_alt</mat-icon>
                            <i>Cliquez ici pour définir un spot</i>
                        </div>
                    }

                    <!-- Cas normal - Pas de modération -->

                    @switch (spot?.file?.generationStatus) {
                        @default {
                            @if (spot?.file?.generationStatus === 30 || spot?.file?.generationStatus === 0) {
                                <!-- Spot prêt -->
                                <div class="thumbnailDivLayer" (click)="playFile(spot.file)">
                                    <mat-icon class="playArrow">play_arrow</mat-icon>
                                </div>

                                <!-- Other Screens -->
                                @if (diffusion.otherScreens > 0) {
                                    <div class="otherScreenCount">
                                        <mat-icon>airplay</mat-icon>
                                        <span>+ {{ diffusion.otherScreens }}</span>
                                    </div>
                                }

                                <!-- Badge Diff priority -->
                                @if (diffusion.isDefault) {
                                    <span class="priorityTag">
                                        <mat-icon>shield</mat-icon>
                                        <span>Défaut</span>
                                    </span>
                                } @else {
                                    @switch (diffusion.diffusionPriority) {
                                        @case (0) {
                                            <span class="priorityTag">
                                                <mat-icon>low_priority</mat-icon>
                                                <span>Basse</span>
                                            </span>
                                        }
                                        @case (1) {
                                            <span class="priorityTag">
                                                <mat-icon>low_priority</mat-icon>
                                                <span>Moyenne</span>
                                            </span>
                                        }
                                        @case (2) {
                                            <span class="priorityTag">
                                                <mat-icon style="transform: rotateX(180deg); line-height: 21px">
                                                    low_priority
                                                </mat-icon>
                                                <span>Haute</span>
                                            </span>
                                        }
                                    }
                                }

                                <div
                                    class="thumbnailDiv"
                                    (click)="playFile(spot.file)"
                                    matTooltip="Voir la vidéo"
                                    [style.background-image]="
                                        getBackgroundImageUrl(spot.file, spot.file?.extensionType === 8)
                                    "
                                ></div>
                            }
                        }
                        @case (10) {
                            <div class="noContentThumb noThumbDiv">
                                <mat-icon>design_services</mat-icon>
                                <i>En attente de traitement</i>
                            </div>
                        }
                        @case (20) {
                            <div class="noContentThumb noThumbDiv">
                                <img
                                    class="processingIcon"
                                    src="../../../../assets/settingcustomslow.gif"
                                    alt="GIF en cours de traitement"
                                />
                                <i class="processingText">En cours de traitement</i>
                                @if (spot.file?.generationProgress) {
                                    <b>{{ spot.file?.generationProgress }} %</b>
                                }
                            </div>
                        }
                        @case (100) {
                            <div class="thumbnailDiv noContentThumb">
                                <mat-icon>broken_image</mat-icon>
                                <i>Erreur de génération du spot</i>
                            </div>
                        }
                    }
                } @else {
                    <!-- Modération en cours -->
                    @for (moderationFile of spot.moderationFile; track $index) {
                        @if (moderationFile.storageId != null) {
                            <!-- Icone en attente de modération -->
                            <div
                                class="thumbnailDivLayer"
                                style="background-color: unset"
                                (click)="playFile(moderationFile)"
                            >
                                <span class="moderationBadge mediaNotModerated">
                                    <mat-icon>safety_check</mat-icon>En attente
                                </span>
                            </div>
                            <!-- Icone 'play' -->
                            <div class="thumbnailDivLayer" (click)="playFile(moderationFile)">
                                <mat-icon class="playArrow">play_arrow</mat-icon>
                            </div>
                            @if (diffusion.otherScreens != 0 && diffusion.otherScreens != null) {
                                <span class="otherScreenCount">
                                    <mat-icon>airplay</mat-icon>
                                    <span>+ {{ diffusion.otherScreens }}</span>
                                </span>
                            }
                            <!-- Thumbnail du spot -->
                            <div
                                class="thumbnailDiv"
                                (click)="playFile(moderationFile)"
                                matTooltip="Voir le spot"
                                style="background-image: url('{{ getBackgroundURL(moderationFile) }}')"
                            ></div>
                        } @else {
                            <div class="thumbnailDivLayer" (click)="playFile(moderationFile)">
                                <span class="moderationBadge mediaNotModerated">
                                    <mat-icon>safety_check</mat-icon>En attente
                                </span>
                            </div>

                            @switch (moderationFile.generationStatus) {
                                @case (10) {
                                    <!-- Génération en attente -->
                                    <div class="thumbnailDiv">
                                        <mat-icon>design_services</mat-icon>
                                        <i>En attente de traitement</i>
                                    </div>
                                }
                                @case (20) {
                                    <!-- Génération en cours -->
                                    <div class="thumbnailDiv">
                                        <img
                                            class="processingIcon"
                                            src="../../../../assets/settingcustomslow.gif"
                                            alt="GIF en cours de traitement"
                                        />
                                        <i class="processingText">En cours de traitement</i>
                                        @if (moderationFile.generationProgress) {
                                            <b>{{ moderationFile.generationProgress }} %</b>
                                        }
                                    </div>
                                }

                                @case (100) {
                                    <!-- Erreur de Génération -->
                                    <div class="noContentThumb noThumbDiv">
                                        <mat-icon>broken_image</mat-icon>
                                        <i>Erreur de génération</i>
                                    </div>
                                }
                                @default {
                                    <!-- Modération vide -->
                                    <div class="thumbnailDiv noContentThumb">
                                        <mat-icon>image_not_supported</mat-icon>
                                        <i>Fichier manquant</i>
                                    </div>
                                }
                            }
                        }
                    }
                }
            }
        </div>

        <!-- MARK: Infos diffusions -->
        <div class="informationContainer" id="infoDiff">
            <article class="triggerIconContainer" [ngClass]="{ lightDiffusionIcons: isLightDiffusionIconsClass() }">
                <!-- Icon for weather -->
                @if (diffusion.trigger.paramWeather) {
                    <span class="material-icons-outlined" [matTooltip]="weatherParams[diffusion.trigger.paramWeather]">
                        {{ weatherParamsIcons[diffusion.trigger.paramWeather] }}
                    </span>
                } @else {
                    <span class="material-icons-outlined inactive">light_mode</span>
                }

                <!-- Icon for temperature -->
                @if (!diffusion.trigger.minTemp && !diffusion.trigger.maxTemp && !diffusion.trigger.paramTemp) {
                    <span class="material-icons-outlined inactive">thermostat</span>
                }

                @if (diffusion.trigger.maxTemp != null || diffusion.trigger.minTemp != null) {
                    <span
                        class="material-icons-outlined"
                        matTooltip="De {{ diffusion.trigger.minTemp }}°C à {{ diffusion.trigger.maxTemp }}°C"
                    >
                        thermostat
                    </span>
                }
                @if (diffusion.trigger.paramTemp && diffusion.trigger.paramTempCondition) {
                    <span
                        class="material-icons-outlined"
                        matTooltip="{{ diffusion.trigger.paramTempCondition }} à {{ diffusion.trigger.paramTemp }}"
                    >
                        thermostat
                    </span>
                }

                <!-- Icon for calendar -->
                @if (diffusion.trigger.diffusionDay.length == 0 || diffusion.trigger.diffusionDay == null) {
                    <span class="material-icons-outlined inactive"> event </span>
                }
                @if (diffusion.trigger.diffusionDay.length != 0 && diffusion.trigger.diffusionDay != null) {
                    <span class="material-icons-outlined"> event </span>
                }

                <!-- Icon for Hours -->
                @if (
                    (diffusion.trigger.paramStartHour == null || !diffusion.trigger.paramStartHour) &&
                    (diffusion.trigger.paramEndHour == null || !diffusion.trigger.paramEndHour)
                ) {
                    <span class="material-icons-outlined inactive"> schedule </span>
                }
                @if (diffusion.trigger.paramStartHour != null && diffusion.trigger.paramEndHour != null) {
                    <span
                        class="material-icons-outlined"
                        matTooltip="diffuse de {{ diffusion.trigger.paramStartHour }} à {{
                            diffusion.trigger.paramEndHour
                        }}"
                    >
                        schedule
                    </span>
                }
            </article>
            <article class="mainInfoContainer">
                <span class="smallTopInfo campaignDate">
                    @if (!diffusion.isPermanent) {
                        {{ diffusion.startDate | date: 'dd/MM/YY' }}
                        -
                        {{ diffusion.endDate | date: 'dd/MM/YY' }}
                    } @else {
                        <!-- Diffusion permanente -->
                        Permanent
                    }

                    <!-- Heures de diffusions -->
                    @if (diffusion.trigger.paramStartHour || diffusion.trigger.paramEndHour) {
                        <span class="smallTopInfo diffusionHours" matTooltip="Horaires de diffusion">
                            @if (diffusion.trigger.paramStartHour) {
                                {{ diffusion.trigger.paramStartHour.slice(0, -3) }}h
                            }

                            @if (diffusion.trigger.paramEndHour) {
                                -
                                {{ diffusion.trigger.paramEndHour.slice(0, -3) }}h
                            }
                        </span>
                    }
                </span>

                <!-- Nom de la diffusion -->
                @if (diffusion.spots.length >= 0) {
                    <p class="campaignName" [matTooltip]="diffusion.name">
                        {{ diffusion.name }}
                    </p>
                }

                <!-- Spot à définir -->
                @if (!diffusion.spots[0].spotId) {
                    <p class="campaignName toDefineName">
                        <i>Spot à définir</i>
                    </p>
                }

                <!-- badge de durée -->
                <span [ngClass]="getDeltaItemClass(diffusion)">
                    {{ getDayDelta(diffusion) }}
                </span>
                <!-- Données sur les spots utilisants des données externes -->
                <span
                    class="externalDataInfos"
                    *ngIf="diffusion.spots[0].externalDatas != null"
                    [matTooltip]="
                        diffusion.spots[0].externalDatas.error
                            ? 'Date de l\'erreur: ' + diffusion.spots[0].externalDatas.lastErrorTime
                            : 'Heure de génération'
                    "
                >
                    <mat-icon
                        *ngIf="!diffusion.spots[0].externalDatas.error"
                        style="font-size: 15px; height: 15px; width: 15px; margin-right: 5px"
                    >
                        update
                    </mat-icon>
                    <mat-icon
                        *ngIf="diffusion.spots[0].externalDatas.error"
                        style="font-size: 15px; height: 15px; width: 15px; margin-right: 5px"
                    >
                        error
                    </mat-icon>
                    <span style="line-height: 15px">
                        {{ getHour(diffusion.spots[0].externalDatas.updateHour) }} h
                    </span>
                </span>

                <!-- Diffusions certains jours -->
                @if (diffusion.trigger.diffusionDay?.length > 0) {
                    <div class="listDay">
                        <section class="days">
                            <span
                                [ngClass]="{
                                    inactive: !diffusion.trigger.diffusionDay.includes(1),
                                }"
                                >L</span
                            >
                            <span
                                [ngClass]="{
                                    inactive: !diffusion.trigger.diffusionDay.includes(2),
                                }"
                                >M</span
                            >
                            <span
                                [ngClass]="{
                                    inactive: !diffusion.trigger.diffusionDay.includes(3),
                                }"
                                >M</span
                            >
                            <span
                                [ngClass]="{
                                    inactive: !diffusion.trigger.diffusionDay.includes(4),
                                }"
                                >J</span
                            >
                            <span
                                [ngClass]="{
                                    inactive: !diffusion.trigger.diffusionDay.includes(5),
                                }"
                                >V</span
                            >
                            <span
                                [ngClass]="{
                                    inactive: !diffusion.trigger.diffusionDay.includes(6),
                                }"
                                >S</span
                            >
                            <span
                                [ngClass]="{
                                    inactive: !diffusion.trigger.diffusionDay.includes(7),
                                }"
                                >D</span
                            >
                        </section>
                    </div>
                }
            </article>
        </div>
    </div>
</div>
